__turbopack_context__.v({
  "callout-banner": "CalloutBanner-module-scss-module__ld9euG__callout-banner",
  "callout-banner__actions": "CalloutBanner-module-scss-module__ld9euG__callout-banner__actions",
  "callout-banner__body": "CalloutBanner-module-scss-module__ld9euG__callout-banner__body",
  "callout-banner__content": "CalloutBanner-module-scss-module__ld9euG__callout-banner__content",
  "callout-banner__decoration": "CalloutBanner-module-scss-module__ld9euG__callout-banner__decoration",
  "callout-banner__eyebrow": "CalloutBanner-module-scss-module__ld9euG__callout-banner__eyebrow",
  "callout-banner__headline": "CalloutBanner-module-scss-module__ld9euG__callout-banner__headline",
  "callout-banner__image": "CalloutBanner-module-scss-module__ld9euG__callout-banner__image",
  "callout-banner__media": "CalloutBanner-module-scss-module__ld9euG__callout-banner__media",
});
